import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { http } from "@/lib/api";
import { useGroup } from "@/lib/GroupContext";

export function PlayerReset() {
  const { setState } = useGroup();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/case/reset");
      setState(data);
      setOpen(false);
      toast.success("Case reset — ready for the next group");
      navigate("/");
    } catch (e) {
      toast.error("Reset failed. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button className="player-reset btn-outline-sm ml-auto" onClick={() => setOpen(true)} data-testid="player-reset-button"><RotateCcw size={16} /> Reset</button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-none border-2 border-[#0b0c0c] max-w-xl" data-testid="player-reset-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-3xl font-black">Are you sure you want to reset?</AlertDialogTitle>
            <AlertDialogDescription className="text-lg text-[#0b0c0c]">
              This will wipe all data: progress, interview records, case notes and the charge decision.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-3 mt-4">
            <AlertDialogCancel className="btn-ghost h-auto" data-testid="player-reset-cancel">Cancel</AlertDialogCancel>
            <button className="btn-spore btn-danger" disabled={busy} onClick={reset} data-testid="player-reset-confirm">Yes, reset</button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
